export default {
  header: {
    'hideMenuBar': 'Nascondi barra del menù',
    'showMenuBar': 'Mostra barra del menù'
  }
}
